import type { TFunction } from 'i18next'

import { SerialPort } from '@/features/controller/configuration/models/raspiProperties/types'

/**
 * How a serial port is named to an operator: the label printed beside the socket on the controller,
 * not the device path the file stores. One place names it, so the connection rows, the port picker
 * and the meter drawer cannot drift apart.
 */
export function describeSerialPort(serialPort: SerialPort, t: TFunction) {
  return serialPort === SerialPort.port2
    ? t('controllers.configuration.device_connections.serial.port_2')
    : t('controllers.configuration.device_connections.serial.port_1')
}
